import { useFormContext } from "react-hook-form";
import { FieldValidator } from "./Form";
import { disabledInputClasses, inputClasses } from "./InputField";
import textData from "../../textData.json";
import { LangContext, LangContextType } from "../../utilities/customHooks";
import { useContext } from "react";
import { cn } from "@lib/utils";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@components/ui/select";

export default function DropdownSingleSelect(
  {
    placeholder,
    name,
    selections,
    allowCustomValue,
    value,
    setValue,
    disabled,
    readOnly,
    validator,
  }
  :
  {
    placeholder?: string,
    name: string,
    selections: {value: string, text: string, frText?: string}[],
    allowCustomValue: boolean,
    value: string | boolean,
    setValue: (value: string | boolean) => void,
    disabled?: boolean,
    readOnly?: boolean,
    validator?: FieldValidator,
  }
) {
  const { langState } = useContext(LangContext) as LangContextType

  const { register, clearErrors } = useFormContext();

  const isReturningBoolean = validator && validator.returnValueType && validator.returnValueType === "boolean";
  const processedValue = typeof value === "boolean" ? (value ? "yes" : "no") : value as string;

  const handleValueChange = (newValue: string) => {
    setValue(isReturningBoolean ? newValue === "yes" : newValue);
    clearErrors(name);
  }

  const isDisabled = disabled || readOnly;

  return (
    <div className="relative">
      {/* Hidden input for react-hook-form registration/validation */}
      <input
        type="hidden"
        {...register(name, {
          validate: () => {
            if (validator?.required && value === "") {
              return textData.Components.Form.DropdownSingleSelect.MakeSelection[langState];
            }
            return true;
          },
        })}
      />
      <Select
        value={processedValue || undefined}
        onValueChange={handleValueChange}
        disabled={isDisabled}
      >
        <SelectTrigger
          id={name}
          className={cn(inputClasses, isDisabled && disabledInputClasses)}
        >
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          {selections.map((selection, index) => (
            <SelectItem key={index} value={selection.value}>
              {langState === "fr" && selection.frText ? selection.frText : selection.text}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}

export const dropdownArrowClasses = `absolute top-1/2 -translate-y-1/2 right-2 border-4 border-solid border-l-transparent border-r-transparent border-b-0 border-t-terteiry`;
